import { configureStore } from '@reduxjs/toolkit'
import { authApi } from '@/services/auth/api'
import { userApi } from '@/services/user/api'
import { productApi } from '@/services/product/api'
import { orderApi } from '@/services/order/api'
import { categoryApi } from '@/services/category/api'

export const store = configureStore({
  reducer: {
    // API slices
    [authApi.reducerPath]: authApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [productApi.reducerPath]: productApi.reducer,
    [orderApi.reducerPath]: orderApi.reducer,
    [categoryApi.reducerPath]: categoryApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      authApi.middleware,
      userApi.middleware,
      productApi.middleware,
      orderApi.middleware,
      categoryApi.middleware
    ),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
